<i18n>
{
	"en": {
		"endpoint" : "Destination",
		"sender" : "Sender",
		"recipient" : "Recipient",
		"messageFormatDescription" : "Message Format",
		"messageTypeDescription" : "Message Type",
		"encoding" : "Message encoding",
		"ediMessageTransportMethod" : "Sending method",
		"endpointUsername": "Username",
		"endpointPassword": "Password",
		"notifyEdipartSaved" : "EDI Part changes successfully saved"
	},
	"no":{
		"endpoint" : "Destinasjon",
		"sender" : "Sender",
		"recipient" : "Mottaker",
		"messageFormatDescription" : "Meldings Format",
		"messageTypeDescription" : "Meldings Type",
		"ediMessageTransportMethod" : "Sendingsmetode",
		"encoding" : "Meldingskoding",
		"endpointUsername": "Brukernavn",
		"endpointPassword": "Passord",
		"notifyEdipartSaved" : "EDI Partens endringer ble lagret"
	}
}
</i18n>

<template>
	<div>
		<div class="details">
			<t-form-group>
				<t-select
					:label="$t('messageTypeDescription')"
					:items="getMessageTypes"
					:selectedItem="ediSetup.messageType"
					disabled
					@change="setMessageType($event)"
				>
					<template v-slot:displayedValue>
						{{getMessageTypeDisplayValue}}
					</template>

					<template v-slot:optionItemValue="slotProps">
						{{displayMessageTypeDescription(slotProps.item)}}
					</template>
				</t-select>

				<t-select
					v-if="selectedMessageMetadata !== null"
					:label="$t('messageFormatDescription')"
					:items="getMessageFormats"
					:selectedItem="ediSetup.messageFormat"
					disabled
					@change="setMessageFormat($event)"
				>
					<template v-slot:displayedValue>
						{{getMessageFormatDisplayValue}}
					</template>

					<template v-slot:optionItemValue="slotProps">
						{{displayMessageFormatDescription(slotProps.item)}}
					</template>
				</t-select>


				
				<t-select
					:label="$t('encoding')"
					:items="getEncodings"
					:selectedItem="ediSetup.encoding"
					@change="setEncoding($event)"
				>
					<template v-slot:displayedValue>
						{{ediSetup.encoding}}
					</template>

					<template v-slot:optionItemValue="slotProps">
						{{(slotProps.item)}}
					</template>
				</t-select>
			</t-form-group>

			<t-form-group>
				<t-text-input
					v-model="ediSetup.sender"
					disabled
					:label="$t('sender')"
				/>
				<t-text-input
					v-model="ediSetup.recipient"
					disabled
					:label="$t('recipient')"
				/>

			</t-form-group>
			<t-form-group>
				<t-text-input
					v-model="ediSetup.endpointUsername"
					disabled
					:label="$t('endpointUsername')"
				/>
				<t-text-input
					v-model="ediSetup.endpointPassword"
					disabled
					:label="$t('endpointPassword')"
				/>

			</t-form-group>

			<t-form-group >
				<t-select
					:label="$t('ediMessageTransportMethod')"
					:items="getSendingMethods"
					:selectedItem="ediSetup.transportMethod"
					disabled
					@change="setTransportMethod($event)"
				>
					<template v-slot:displayedValue>
						{{getTransportMethodDescriptionDisplayValue}}
					</template>

					<template v-slot:optionItemValue="slotProps">
						{{displayTransportMethodDescription(slotProps.item)}}
					</template>
				</t-select>
				<t-text-input
					v-model="ediSetup.endpoint"
					:label="$t('endpoint')"
					disabled
					@input="updatePathIfFtp($event)"
					@blur="removePathIfFtp"
				/>
				<t-text-input
					v-if="isFTP"
					v-model="ediSetup.endpointPath"
					disabled
					:label="$t('path')"
				/>
			</t-form-group>
		</div>
	</div>

</template>

<script>

import { mapGetters } from './store/details/ediSetupDetails.store';

export default {

	props: { ediSetup: Object, messageMetadata: Array, transportMethods:Array },

	data() {
		return { selectedMessageMetadata: null, };
	},
	computed: {
		...mapGetters(['edipart']),
		getMessageFormats() {
			if (this.selectedMessageMetadata)
				return this.selectedMessageMetadata.supportedMessageFormats.map(x => x.format);
			return [this.ediSetup.messageFormat];
		},
		getMessageTypes() {
			return this.messageMetadata.map(x => x.format);
		},
		getEncodings() {
			if (!this.selectedMessageMetadata)
				return [];
			let encodings = this.selectedMessageMetadata.supportedEncodings;
			return Object.keys(this.selectedMessageMetadata.supportedEncodings).map(key => encodings[key]);
		},
		isFTP() {
			return this.ediSetup.transportMethodDescription === 'FTP';
		},
		getMessageFormatDisplayValue() {
			let firstMessageFormat = this.getFirstMessageFormat();
			return firstMessageFormat.name;
		},
		getTransportMethodDescriptionDisplayValue() {
			return this.ediSetup.transportMethodDescription;
		},
		getMessageTypeDisplayValue() {
			return this.ediSetup.messageTypeDescription;
		},
		getSendingMethods() {
			return this.transportMethods.map(x => x.transportMethod);
		},
	},
	watch: {
		selectedMessageMetadata: {
			handler: function() {
				this.$emit('onMessageTypeChanged', this.selectedMessageMetadata);
			},
			deep: true
		},
	},
	created() {
		this.selectedMessageMetadata = this.messageMetadata.find(x => x.format === this.ediSetup.messageType);
	},
	methods:{
		removePathIfFtp() {
			if (!this.isFTP)
				return;

			let index = this.ediSetup.endpoint.indexOf('/');
			if (index > 0 ) {
				this.ediSetup.endpoint = this.ediSetup.endpoint.replace(this.ediSetup.endpointPath, '');
				this.ediSetup.endpoint = this.ediSetup.endpoint.replace('/', '');
			}
		},
		updatePathIfFtp(event) {
			if (!this.isFTP)
				return;
			if (event.toLowerCase().indexOf('ftp://') > 0)
				this.ediSetup.endpoint = event.toLowerCase().replace('ftp://', '');
			if (event.indexOf('//') > 0)
				this.ediSetup.endpoint = event.replace('//', '');
			if (event.indexOf(':') > 0)
				this.ediSetup.endpoint = event.replace(':', '');

			this.ediSetup.endpoint = this.ediSetup.endpoint.replace('ftp//', '');
			let index = this.ediSetup.endpoint.indexOf('/');

			if ( index > 0) {
				this.ediSetup.endpointPath = this.ediSetup.endpoint.substring(index + 1);
			}
		},
		getFirstMessageFormat() {
			let messageTypeMetadata = this.messageMetadata.find(x => x.format === this.ediSetup.messageType);
			if (!messageTypeMetadata)
				return { messageFormat: this.ediSetup.messageFormat, name: this.ediSetup.messageFormatDescription };
			let messageFormatMetadata = messageTypeMetadata.supportedMessageFormats.find(x => x.format === this.ediSetup.messageFormat);
			if (messageFormatMetadata)
				return messageFormatMetadata;
			// eslint-disable-next-line prefer-destructuring
			let firstMessageFormat =  messageTypeMetadata.supportedMessageFormats[0];
			return firstMessageFormat;
		},
		getCurrentMessageType() {
			this.selectedMessageMetadata = this.messageMetadata.find(x => x.format === this.ediSetup.messageType);
		},
		setMessageFormat(value) {
			let messageFormats = this.selectedMessageMetadata.supportedMessageFormats;
			let selectedMessageFormat = messageFormats.find(x => x.format === value);
			this.ediSetup.messageFormatDescription = selectedMessageFormat.name;
			this.ediSetup.messageFormat = value;
		},

		setEncoding(value) {
			this.ediSetup.encoding = value;
		},
		setTransportMethod(value) {
			let selectedTransportMethod = this.transportMethods.find(x => x.transportMethod === value);
			this.ediSetup.transportMethodDescription = selectedTransportMethod.transportMethodDescription;
			this.ediSetup.transportMethod = value;
		},

		setMessageType(value) {
			this.selectedMessageMetadata = this.messageMetadata.find(x => x.format === value);
			this.ediSetup.messageTypeDescription = this.selectedMessageMetadata.name;
			this.ediSetup.messageType = value;

			let firstMessageFormat = this.getFirstMessageFormat();
			if (!firstMessageFormat)
				return;
			this.ediSetup.messageFormatDescription = firstMessageFormat.name;
			this.ediSetup.messageFormat = firstMessageFormat.format;
		},
		displayMessageFormatDescription(messageFormat) {
			if (this.selectedMessageMetadata)
				return this.selectedMessageMetadata.supportedMessageFormats.find(x => x.format === messageFormat).name;
			return this.ediSetup.messageFormatDescription;
		},
		displayTransportMethodDescription(transportMethod) {
			return this.transportMethods.find(x => x.transportMethod === transportMethod).transportMethodDescription;
		},
		displayMessageTypeDescription(messageType) {
			return this.messageMetadata.find(x => x.format === messageType).name;
		},
	}
};
</script>

<style lang="scss" scoped>
	@import '~@/components/evergreen/scss/colors';
	@import '~@/components/evergreen/scss/text';
.details{
	display: grid;
	grid-template-columns: repeat(4, minmax(220px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
}

.transport-method-grid{
	display:grid;
	grid-template-columns: 100px;
}

hr {
	grid-column: 1 / auto-fill;
	height: 1px;
	background: get-color($border, 'default');
	width: 100%;
	margin-top: 0;
	margin-bottom: 0;
	border: 0;
	}
</style>